import { Component } from 'react';

import Field from './Field';
import Toggle from './Toggle';

class ToggleField extends Component {
	handleChange = (e, form, field) => {
		const { binaryValue } = this.props;

		let checkedValue = e.target.checked;

		if (binaryValue) {
			checkedValue = checkedValue == true ? 1 : 0;
		}

		form.setFieldValue(field.name, checkedValue);

		if (this.props.onChange) {
			this.props.onChange(checkedValue, form, field);
		}
	};

	handleBlur = (e, form, field) => {
		if (this.props.onBlur) {
			this.props.onBlur(e, form, field);
		}
		form.setFieldTouched(field.name);
	};

	renderInput = props => {
		const { form, field } = props;
		// Need to null isRequired or it is passed down to toggle in rest, and throws an error because the toggle element doesn't recognize it.
		const { readOnly, isRequired = null, ...rest } = this.props;
		const attributes = {
			...rest
		};

		if (attributes.binaryValue) {
			delete attributes.binaryValue;
		}

		return <Toggle {...attributes} value={field.value} onChange={e => this.handleChange(e, form, field)} onBlur={e => this.handleBlur(e, form, field)} readOnly={readOnly} />;
	};

	render() {
		return <Field {...this.props} value={this.props.value} className="form-field-toggle" render={props => this.renderInput(props)} />;
	}
}

export default ToggleField;
